import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket() {
    const token = localStorage.getItem("token");
    let parsedToken = null;
    
    try {
      if (token) {
        // Token pode ser uma string JSON ou uma string simples
        parsedToken = token.startsWith('"') || token.startsWith('{') 
          ? JSON.parse(token) 
          : token;
      }
    } catch (error) {
      console.error("Error parsing token:", error);
      parsedToken = token; // Usa o token como está se não for JSON
    }
    
    const backendUrl = getBackendUrl();
    if (!backendUrl) {
      console.error("Backend URL não configurada!");
      return null;
    }
    
    return openSocket(backendUrl, {
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: 5,
      query: parsedToken ? {
        token: parsedToken,
      } : {},
    });
}

export default connectToSocket;